// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "label-1mq9z";
var _5 = "header-Q0u4I";
var _6 = "title-2M1eG";
var _7 = "paper-2xlIi";
var _8 = "button-3uVwI";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "label", _5 as "header", _6 as "title", _7 as "paper", _8 as "button" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "label": _4, "header": _5, "title": _6, "paper": _7, "button": _8 }
